import { useState } from 'react'
import { useMap } from './useMap' // Import your map hook

interface Coordinates {
  latitude: number
  longitude: number
}

export const useAdress = () => {
  const { isLoaded } = useMap() // Get the loading state
  const [address, setAddress] = useState<string>('')
  const [addressComponents, setAddressComponents] = useState<any[]>([])
  const [coordinates, setCoordinates] = useState<Coordinates | null>(null)
  const [predictions, setPredictions] = useState<
    google.maps.places.AutocompletePrediction[]
  >([])

  const fetchPredictions = (input: string) => {
    // Check if API is loaded before proceeding
    if (!isLoaded || !window.google?.maps?.places) {
      console.warn('Google Maps API not loaded yet')
      return
    }

    if (!input || input.length < 2) {
      setPredictions([])
      return
    }

    const autocompleteService = new google.maps.places.AutocompleteService()
    autocompleteService.getPlacePredictions(
      {
        input,
        componentRestrictions: { country: 'sk' },
        // types: ['street_address', 'premise', 'subpremise'],
      },
      (results: any, status: any) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && results) {
          setPredictions(results)
        } else {
          setPredictions([])
        }
      }
    )
  }

  const fetchPlaceDetails = (placeId: string) => {
    if (!isLoaded || !window.google?.maps?.places) {
      console.warn('Google Maps API not loaded yet')
      return
    }

    const placesService = new google.maps.places.PlacesService(
      document.createElement('div')
    )

    placesService.getDetails(
      {
        placeId: placeId,
        fields: ['geometry', 'formatted_address', 'address_components'],
      },
      (place, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && place) {
          // Uloženie address components
          if (place.address_components) {
            setAddressComponents(place.address_components)
          }

          // Uloženie súradníc
          if (place.geometry?.location) {
            const lat = place.geometry.location.lat()
            const lng = place.geometry.location.lng()
            setCoordinates({
              latitude: lat,
              longitude: lng,
            })
          }
        }
      }
    )
  }

  const handleAddressChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newAddress = e.target.value
    setAddress(newAddress)

    // Only fetch predictions if API is loaded
    if (isLoaded) {
      fetchPredictions(newAddress)
    }
  }

  const handleAddressSelect = (
    prediction: google.maps.places.AutocompletePrediction
  ) => {
    setAddress(prediction.description)
    // Získanie detailov miesta vrátane súradníc
    fetchPlaceDetails(prediction.place_id)
  }

  return {
    handleAddressChange,
    handleAddressSelect,
    predictions,
    isLoaded,
    address,
    addressComponents,
    coordinates,
  }
}
